import React from 'react';
import PropTypes from 'prop-types';
import CheckBox from '../form-controls/CheckBox';
import SubmitModal from '../shared/SubmitModal';
import StorefrontPersona from './StorefrontPersona';
import WarrantyAccess from './WarrantyAccess';
import Branches from './Branches';
import Clone from './Clone';
import Authorize from '../Authorize';
import Loading from '../Loading';
import UserHelper from '../../helpers/UserHelper';
import Notifications from '../../services/Notifications';

const UserRoles = ({
    user,
    persona,
    storefront,
    modals,
    handlers,
    localized,
    currentUser,
    branches
}) => {
    return (
        <div className="sub flex">
            {/* Storefront & Persona */}
            <div>
                <div className="role button-wrapper">
                    <div>
                        <div className="label">{localized.Storefront}</div>
                        <span className="current" style={{ marginLeft: '4px' }}>{storefront.displayName}</span>
                    </div>
                    <div>
                        <div className="label">{localized.Persona}</div>
                        <span className="current" style={{ marginLeft: '4px' }}>{persona.label}</span>
                    </div>
                    <div className="button-wrapper">
                        <button className="remove">
                            <a className="link" style={{ fontSize: '1.6rem' }} onClick={handlers.openStorefrontModal}>
                                {localized.UpdatePersonaStorefront}
                            </a>
                        </button>
                    </div>
                </div>
            </div>

            {/* Warranty Access */}
            <Authorize as={['Administrator', 'StorefrontAdministrator']}>
                <div>
                    <CheckBox checked={UserHelper.hasRoles(['HasWarrantyAccess'], user)} label="Warranty Claims:" onClick={handlers.openWarrantyModal} />

                    <div className="button-wrapper">
                        <button className="remove">
                            <a className="link" style={{ fontSize: '1.6rem' }} onClick={handlers.openWarrantyModal}>
                                {localized.UpdateWarrantyAccess}
                            </a>
                        </button>
                    </div>
                </div>
            </Authorize>

            {/* Branch Access */}
            {handlers.hasAssignedBranches && (
                <Authorize as={['Administrator', 'StorefrontAdministrator']}>
                    <div style={{ maxWidth: '11vw' }}>
                        <div>
                            <div className="label">{localized.DefaultBranches}</div>
                            <span className="current" style={{ marginLeft: '4px' }}>
                                {branches.available.find(x => x.isDefault)?.number || 'N/A'}
                            </span>
                        </div>
                        <div>
                            <div className="label">{localized.AssignedBranches}</div>
                            <span className="current" style={{ marginLeft: '4px' }}>
                                {branches.assigned.length > 0 ? branches.assigned.join(', ') : 'None'}
                            </span>
                        </div>
                        <div className="button-wrapper">
                            <button className="remove">
                                <a className="link" style={{ fontSize: '1.6rem' }} onClick={handlers.openBranchModal}>
                                    {localized.UpdateAssignedBranches}
                                </a>
                            </button>
                        </div>
                    </div>
                </Authorize>
            )}

            {/* Clone User */}
                <div className="button-wrapper">
                    <button className="remove">
                        <a className="link" style={{ fontSize: '1.6rem' }} onClick={handlers.openCloneModal}>
                            Clone User Profile
                        </a>
                    </button>
                </div>

            {/* Modals */}
            <SubmitModal
                isOpen={modals.storefront}
                onSubmit={handlers.saveStorefrontPersona}
                onClose={handlers.closeStorefrontModal}
                submitText={localized.Save}
                closeText={localized.Cancel}
            >
                <StorefrontPersona
                    updateStorefrontPersona={handlers.setStorefrontPersona}
                    currentStorefront={{ value: storefront.id, label: storefront.displayName }}
                    currentPersona={persona}
                    currentUser={currentUser}
                />
            </SubmitModal>

            <SubmitModal
                isOpen={modals.warranty}
                onSubmit={handlers.saveWarrantyAccess}
                onClose={handlers.closeWarrantyModal}
                submitText={localized.Save}
                closeText={localized.Cancel}
            >
                <WarrantyAccess
                    user={user}
                    updateSelectedRoles={handlers.setWarrantyRoles}
                />
            </SubmitModal>

            <SubmitModal
                isOpen={modals.branches}
                onSubmit={handlers.saveBranches}
                onClose={handlers.cancelBranchModal}
                submitText={localized.Save}
                closeText={localized.Cancel}
            >
                <Branches
                    header={localized.AssignedBranches}
                    updateBranches={handlers.setModalBranches}
                    user={user}
                    availableBranches={branches.available}
                    modalBranches={branches.modal}
                />
            </SubmitModal>

            <SubmitModal
                isOpen={modals.clone}
                onSubmit={handlers.handleCloneSave}
                onClose={handlers.closeCloneModal}
                submitText="Apply"
                closeText={localized.Cancel}
            >
                {handlers.cloneProcessing ? (
                    <Loading />
                ) : (
                    <Clone
                        isRoleClone={handlers.isRoleClone}
                        setIsRoleClone={handlers.toggleRoleClone}
                        setUsersToClone={handlers.setUsersToClone}
                        user={user}
                        usersToClone={handlers.usersToClone}
                        updateUsersToClone={handlers.updateUsersToClone}
                        CloneProcessing={handlers.cloneProcessing}
                    />
                )}
            </SubmitModal>
        </div>
    );
};

UserRoles.propTypes = {
    user: PropTypes.object.isRequired,
    persona: PropTypes.object.isRequired,
    storefront: PropTypes.object.isRequired,
    modals: PropTypes.object.isRequired,
    handlers: PropTypes.object.isRequired,
    localized: PropTypes.object.isRequired,
    currentUser: PropTypes.object.isRequired,
    branches: PropTypes.object.isRequired,
    StorefrontConfig: PropTypes.object.isRequired
};

export default UserRoles;
